export default __webpack_public_path__ + "static/media/download.33fe8623.svg";